import React from 'react';
import { Link } from 'react-router-dom';
import StrokedText from '../Participation/Nodes/StrokedText';
import ScoreFill from '../OrgTree/Nodes/ScoreFill';
import OrgTreeWeightBadge, {
  ORG_TREE_WEIGHT_ICON_SIZE,
} from '../OrgTree/Nodes/OrgTreeWeightBadge';

const RubricTeamNode = ({
  radius,
  showWeights,
  workspaceId,
  rubricId,
  teamSchemeById = {},
  node: {
    x: y,
    y: x,
    data: { id, name, score, weight },
  },
}) => {
  const scoreIsValid = typeof score === 'number' && !isNaN(score);
  const schemeLabel = teamSchemeById[id] ?? null;

  const { wrapperProps, wrapperComponent: Wrapper } = scoreIsValid
    ? {
        wrapperProps: {
          to: `/w/${workspaceId}/teams/${id}/rubrics/${rubricId}`,
        },
        wrapperComponent: Link,
      }
    : { wrapperProps: {}, wrapperComponent: React.Fragment };

  const hasScheme = Boolean(schemeLabel);
  const schemeX = -(radius + 4);
  const schemeY = showWeights && hasScheme ? 8 : hasScheme ? 1 : null;

  // OrgTreeWeightBadge text sits at local y = ICON/2 + 1; lift the group when a scheme
  // label shares the left side (mirrors the old nameY = -5 / schemeY = 8 split).
  const weightBadgeTextY = ORG_TREE_WEIGHT_ICON_SIZE / 2 + 1;
  const weightBadgeOffsetY =
    showWeights && hasScheme
      ? -3 - weightBadgeTextY
      : -ORG_TREE_WEIGHT_ICON_SIZE / 2 + 1;

  const weightBadgeTransform = `translate(${-(
    radius +
    ORG_TREE_WEIGHT_ICON_SIZE +
    6
  )}, ${weightBadgeOffsetY})`;

  return (
    <g transform={`translate(${x},${y})`} className="rubric-org-tree-team">
      <ScoreFill radius={radius} score={score} />
      {schemeLabel ? (
        <StrokedText
          strokeWidth={2}
          strokeColor="#2c2c2c"
          textAnchor="end"
          fill="#b8d4f0"
          x={schemeX}
          y={schemeY}
          dominantBaseline="middle"
          className="team-scheme-label"
          fontSize={8}
        >
          {schemeLabel}
        </StrokedText>
      ) : null}
      {showWeights ? (
        <OrgTreeWeightBadge weight={weight} transform={weightBadgeTransform} />
      ) : null}
      <Wrapper {...wrapperProps}>
        <StrokedText
          strokeWidth={3}
          strokeColor="#2c2c2c"
          textAnchor="start"
          fill="#fff"
          x={radius + 4}
          y={1}
          dominantBaseline="middle"
          className="team-name"
          fontSize={10}
        >
          {name}
        </StrokedText>
      </Wrapper>
    </g>
  );
};

export default RubricTeamNode;
